import styled from '@emotion/styled'

interface LazyScrollingContainerProps {
  withOverflowScroll?: boolean
  maxHeight?: string | number
}

export const LazyScrollingContainer = styled.ul<LazyScrollingContainerProps>`
  ${({ maxHeight }) => maxHeight && `max-height: ${typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight}`};
  overflow-y: ${({ withOverflowScroll }) => (withOverflowScroll ? 'scroll' : 'initial')};
`
